<template>
  <div v-if="shouldRenderConfig" v-show="IsPreview2D" :class="getClassName">
    <button type="button" class="btn btn-primary" @click="onDownload()">
      {{ $t("Download PDF") }}
    </button>
  </div>
</template>
<script>
import { usePreview3DStore } from "@/stores/modules/preview3D";
import { usePackingOptionsStore } from "@/stores/modules/packingOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(usePreview3DStore, ["getActivePreview"]),
    IsPreview2D: function () {
      return this.getActivePreview == "preview2D";
    }
  },
  methods: {
    ...mapActions(usePackingOptionsStore, ["packingDownloadPdf"]),
    onDownload: function () {
      this.packingDownloadPdf();
    }
  }
};
</script>
